module.exports = __webpack_public_path__ + "img/bolt.709ddc0.svg";